import React from "react";
import { FlexContainer } from "src/components";
import FormField from "src/components/FormField";
import { TextLabel, ErrorMessage } from "../../style";

export const ArticleTitleField = ({ value, onChange, error }) => {
    return (
        <FlexContainer>
            <TextLabel color="#000000" fontSize="16px" fontWeight="bold"
            >  Article Title </TextLabel>
            <FormField borderRadius="10px" size="14px" height="50px"
                placeholderColor="#808080" border="1px solid #D8DEEC"
                backgroundColor={"#FFFFFF 0% 0% no-repeat padding-box"}
                boxShadow="0px 3px 6px #00000029"
                opacity="1"
                align="left"
                width="100%"
                type="text"
                placeholder={"Enter article title…"}
                onChange={(e) => onChange(e.target.value)}
                maxLength="100"
                value={value}
                readOnly={false}
                style={{ boxShadow: "0px 3px 6px #00000029" }}
            />
            <ErrorMessage>{error}</ErrorMessage>
        </FlexContainer>
    );
};
